import {
  IS_LOADING,
  SUCCESS_MESSAGE,
  ERROR_MESSAGE,
  TEXT_LINK,
  TEXT_LINK_FAIL,
  TEXT_LINK_SUCCESS,
  UPDATE_VIEWPORT,
  MOBILE_TOGGLE_DRAWER,
  TRIGGER_INTERCOM
} from "app/DealMachineCore/types";

import PrivateAPI from "app/DealMachineCore/apis/DealMachinePrivateAPI";
const private_api = PrivateAPI.create();

export const textLink = ({ token, phone_number }) => {
  return dispatch => {
    dispatch({ type: IS_LOADING, payload: true });
    dispatch({ type: TEXT_LINK });

    private_api.textLink(token, phone_number).then(response => {
      if (response.problem != null) {
        textLinkFail(dispatch, response.problem);
      } else if (response.data.error != false) {
        textLinkFail(dispatch, response.data.error);
      } else {
        textLinkSuccess(dispatch);
      }
    });
  };
};

const textLinkFail = (dispatch, error) => {
  dispatch({ type: TEXT_LINK_FAIL, payload: error });
  dispatch({
    type: ERROR_MESSAGE,
    payload: { message: error, title: "Error" }
  });
};
const textLinkSuccess = dispatch => {
  dispatch({
    type: TEXT_LINK_SUCCESS
  });
  dispatch({
    type: SUCCESS_MESSAGE,
    payload: {
      message: "Your link has be sent to your phone.",
      title: "Success!"
    }
  });
};

export const updateViewPort = ({ width, height, sidebar_width }) => {
  return {
    type: UPDATE_VIEWPORT,
    payload: { width, height, sidebar_width }
  };
};
export const mobileToggleDrawer = toggle => {
  return {
    type: MOBILE_TOGGLE_DRAWER,
    payload: toggle
  };
};

export const iOSBrowserCheck = () => {
  var isiOSMobile = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  var iOSSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  if (iOSSafari) {
    return true;
  } else if (isiOSMobile) {
    return true;
  } else {
    return false;
  }
};

export const triggerIntercom = toggle => {
  return {
    type: TRIGGER_INTERCOM,
    payload: toggle
  };
};
